import questionSimilar from './src'
questionSimilar.install = Vue => {
    Vue.component(questionSimilar.name, questionSimilar)
}
export default questionSimilar



// WEBPACK FOOTER //
// ./packages/question-similar/index.js